// Views
import Bills from '@/views/bills.vue';
import Devices from '@/views/devices.vue';
import Quiz from '@/views/quiz.vue';
import Help from '@/views/help.vue';
import NotFound from '@/views/notfound.vue';

export default [
  { path: '/', redirect: '/devices/' },

  { path: '/bills/', redirect: '/bills/50-europa/' },
  { path: '/bills/:denomination-:series/', name: 'bills', component: Bills },
  { path: '/bills/:denomination-:series/:feature/', name: 'features', component: Bills },

  { path: '/devices/', component: Devices },
  { path: '/quiz/', component: Quiz },
  { path: '/help/', component: Help },

  { path: '*', component: NotFound },
];



// WEBPACK FOOTER //
// ./src/router/routes.js